export enum RuleActionType {
	BAR_SIM,
	SEND_EMAIL,
	NOTIFY
}